import React, { useEffect, useState } from 'react'
import MaterialTable, { MTableToolbar } from '@material-table/core'
import { Button, Paper } from '@material-ui/core'
import { getPermissions } from '../../services/permissions/getPermissions'
import AddPermissionsDialog from './AddPermissionsDialog'

export default function PermissionsTable() {
  const [openDialog, setOpenDialog] = useState(false)
  const [permissionsData, setPermissionsData] = useState([])

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const permissions = await getPermissions()
        setPermissionsData([...permissions])
      } catch (error) {
        alert('Error al traer los permisos')
      }
    }
    fetchPermissions()
    return () => {
      
    }
  }, [])

  const handleClickOpen = () => {
    setOpenDialog(true)
  };

  const handleClose = () => {
    setOpenDialog(false)
  };

  return (
    <div style={{padding: '20px'}}>
      <AddPermissionsDialog open={openDialog} handleClose={handleClose} />
      <MaterialTable
        columns={[
          { 
            title: "id", 
            field: "id", 
            type: "string",
            hidden: true,
            editable: false,
            searchable: false,
          },
          { 
            title: "Nombre del permiso",
            field: "name", 
            type: "string",
            width: "20%",
            editable: false,
            searchable: true,
          },
          { 
            title: "Categorias", 
            field: "categories",
            width: "80%",
            render: rowData => rowData.categories.join(' | ')
          },
        ]}
        title={'Permisos'}
        options={{
          headerStyle: {
            position: 'sticky',
            top: 0,
            zIndex: 1
          },
          minbodyHeight: "85vh",
          maxBodyHeight: '85vh',
          actionsColumnIndex: -1,
          pageSize: 10,
          emptyRowsWhenPaging: false,
          search: true,
          searchFieldVariant: 'outlined',
          searchFieldStyle: {height: '40px'},
          paging: true,
          sorting: false,
          editable: false,
          rowStyle: (x, index) => {
            if (index % 2) {
              return { fontFamily: "roboto", fontSize: "small" }
            }
            return { fontFamily: "roboto", fontSize: "small", backgroundColor: '#EEEEEE', borderTopLeftRadius: '8px' }
          },
        }}
        data={permissionsData}
        components={{
          Container: props => <Paper {...props} elevation={0}/>,
          Toolbar: (props) => (
            <div
              style={{
                backgroundColor: '#EEEEEE',
                paddingBottom: '15px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <div style={{width: '85%', display: 'inline-block'}}>
                <MTableToolbar {...props} />
              </div>
              <div style={{width: '20%', display: 'inline-block'}}>
                <Button
                  variant="contained"
                  size='small'
                  disableElevation
                  style={{backgroundColor: '#F59D00', height: '40px', float: 'right',  marginRight: '20%'}}
                  onClick={() => handleClickOpen()}
                >
                  CREAR PERMISO
                </Button>
              </div>
            </div>
          )
        }}
        localization={{
          toolbar: {
              nRowsSelected: '{0} registro(s) seleccionado(s)',
              searchPlaceholder: 'Buscar',
              searchTooltip: 'Buscar'
          },
          header: {
              actions: 'Acciones'
          },
          body: {
              emptyDataSourceMessage: 'No hay permisos',
              filterRow: {
                  filterTooltip: 'Filtro'
              }
          },
          pagination: {
            labelRowsSelect: 'permisos',
            labelDisplayedRows: '{from}-{to} de {count}',
            firstTooltip: 'Primera página',
            previousTooltip: 'Anterior',
            nextTooltip: 'Siguiente',
            lastTooltip: 'Última página'
          }
        }}
      />
    </div>
  );
}
